export default __webpack_public_path__ + "static/media/intl-contracting-light.644ab779.png";